module.exports = __webpack_public_path__ + "img/header-store-locator.9449e671.jpg";